// import SKURateManager from '@scope/views/sku-rate-manager'
// import SKURateManagerCreate from '@scope/views/sku-rate-manager/create'
import InvoiceInfoManager from '@scope/views/invoice-info-manager'
import InvoiceAddressManager from '@scope/views/invoice-address-manager'
import InvoiceApplicationManager from '@scope/views/invoice-application-manager'
import BillSubscriptionManager from '@scope/views/bill-subscription-manager'
import BillAccountManager from '@scope/views/bill-account-manager'
import ExchangeRateManager from '@scope/views/exchange-rate-manager'
import TenantManager from '@scope/views/tenant-manager'
import ReportProject from '@scope/views/report-project'
import ChannelManager from '@scope/views/channel-manager'
import License from '@scope/views/license'
import BillManager from '@scope/views/bill-manager'
import VoucherManager from '@scope/views/voucher-manager'
import OpensrouceList from '@scope/views/opensource-reports'
import OperationRecords from '@scope/views/operation-records'
import PendingPayment from '@scope/views/pending-payment'
import TechSupport from '@scope/views/accounts/tech-support'
import WecomExtGroups from '@scope/views/wecom-ext-groups'
// import CloudBillAccount from '@scope/views/cloud-bill-account'
// import SKUProjectManager from '@scope/views/sku-project-manager'
// import SKUSubcategoryManager from '@scope/views/sku-subcategory-manager'
// import SKUOriginalManager from '@scope/views/sku-original-manager'
import Layout from '@/layouts/RouterView'
import store from '@/store'
import i18n from '@/locales'

export default {
  index: 98,
  meta: {
    label: i18n.t('scope.text_283'),
    icon: 'menu-tenant',
    hidden: () => {
      if (store.getters.scope === 'system') return false
      return true
    },
  },
  menus: [
    {
      meta: {
        label: i18n.t('scope.text_283'),
      },
      subGroup: 'tenant',
      submenus: [
        {
          path: '/tenant-manager',
          meta: {
            label: i18n.t('scope.text_283'),
            hidden: () => store.getters.scope !== 'system',
          },
          component: Layout,
          children: [
            {
              name: 'tenantManager',
              path: '',
              component: TenantManager,
            },
          ],
        },
      ],
    },
    {
      meta: {
        label: i18n.t('scope.text_285'),
      },
      subGroup: 'tenant',
      submenus: [
        {
          path: '/channel-manager',
          meta: {
            label: i18n.t('scope.text_286'),
            hidden: () => store.getters.scope !== 'system',
          },
          component: Layout,
          children: [
            {
              name: 'ChannelManager',
              path: '',
              component: ChannelManager,
            },
          ],
        },
        {
          path: '/report-project',
          meta: {
            label: i18n.t('scope.text_287'),
            hidden: () => store.getters.scope !== 'system',
          },
          component: Layout,
          children: [
            {
              name: 'ReportProject',
              path: '',
              component: ReportProject,
            },
          ],
        },
      ],
    },
    {
      meta: {
        label: i18n.t('scope.text_288'),
      },
      subGroup: 'tenant',
      submenus: [
        {
          path: '/license',
          meta: {
            label: i18n.t('scope.text_288'),
            hidden: () => store.getters.scope !== 'system',
          },
          component: Layout,
          children: [
            {
              name: 'License',
              path: '',
              component: License,
            },
          ],
        },
        {
          path: '/backend-tech-support',
          meta: {
            label: i18n.t('scope.tech_support_management'),
            hidden: () => store.getters.scope !== 'system',
          },
          component: Layout,
          children: [
            {
              name: 'BackendTechSupport',
              path: '',
              component: TechSupport,
            },
          ],
        },
        {
          path: '/wecom-ext-groups',
          meta: {
            label: i18n.t('scope.wecom_ext_groups_list'),
            hidden: () => store.getters.scope !== 'system',
          },
          component: Layout,
          children: [
            {
              name: 'WecomExtGroups',
              path: '',
              component: WecomExtGroups,
            },
          ],
        },
      ],
    },
    {
      meta: {
        label: i18n.t('scope.operation_report'),
      },
      subGroup: 'tenant',
      submenus: [
        {
          path: '/opensource-list',
          meta: {
            label: i18n.t('scope.opensource_list'),
            hidden: () => store.getters.scope !== 'system',
          },
          component: Layout,
          children: [
            {
              name: 'OpensrouceList',
              path: '',
              component: OpensrouceList,
            },
          ],
        },
        {
          path: '/operation-records',
          meta: {
            label: i18n.t('scope.operation_records_list'),
            hidden: () => store.getters.scope !== 'system',
          },
          component: Layout,
          children: [
            {
              name: 'OperationRecords',
              path: '',
              component: OperationRecords,
            },
          ],
        },
      ],
    },
    {
      meta: {
        label: i18n.t('scope.text_289'),
      },
      subGroup: 'tenant',
      submenus: [
        {
          path: '/bill-account-manager',
          meta: {
            label: i18n.t('scope.text_290'),
            hidden: () => store.getters.scope !== 'system',
          },
          component: Layout,
          children: [
            {
              name: 'BillAccountManager',
              path: '',
              component: BillAccountManager,
            },
          ],
        },
        {
          path: '/bill-subscription-manager',
          meta: {
            label: i18n.t('scope.text_291'),
            hidden: () => store.getters.scope !== 'system',
          },
          component: Layout,
          children: [
            {
              name: 'BillSubscriptionManager',
              path: '',
              component: BillSubscriptionManager,
            },
          ],
        },
        {
          path: '/bill-manager',
          meta: {
            label: i18n.t('scope.text_292'),
            hidden: () => store.getters.scope !== 'system',
          },
          component: Layout,
          children: [
            {
              name: 'BillManager',
              path: '',
              component: BillManager,
            },
          ],
        },
        {
          path: '/pending-payment',
          meta: {
            label: i18n.t('scope.text_266'),
            hidden: () => store.getters.scope !== 'system',
          },
          component: Layout,
          children: [
            {
              name: 'PendingPayment',
              path: '',
              component: PendingPayment,
            },
          ],
        },
        {
          path: '/voucher-manager',
          meta: {
            label: i18n.t('scope.text_293'),
            hidden: () => store.getters.scope !== 'system',
          },
          component: Layout,
          children: [
            {
              name: 'VoucherManager',
              path: '',
              component: VoucherManager,
            },
          ],
        },
        {
          path: '/invoice-info-manager',
          meta: {
            label: i18n.t('scope.text_294'),
            hidden: () => store.getters.scope !== 'system',
          },
          component: Layout,
          children: [
            {
              name: 'InvoiceInfoManager',
              path: '',
              component: InvoiceInfoManager,
            },
          ],
        },
        {
          path: '/invoice-address-manager',
          meta: {
            label: i18n.t('scope.text_295'),
            hidden: () => store.getters.scope !== 'system',
          },
          component: Layout,
          children: [
            {
              name: 'InvoiceAddressManager',
              path: '',
              component: InvoiceAddressManager,
            },
          ],
        },
        {
          path: '/invoice-application-manager',
          meta: {
            label: i18n.t('scope.text_296'),
            hidden: () => store.getters.scope !== 'system',
          },
          component: Layout,
          children: [
            {
              name: 'InvoiceApplicationManager',
              path: '',
              component: InvoiceApplicationManager,
            },
          ],
        },
        {
          path: '/exchange-rate-manager',
          meta: {
            label: i18n.t('scope.text_297'),
            hidden: () => store.getters.scope !== 'system',
          },
          component: Layout,
          children: [
            {
              name: 'ExchangeRateManager',
              path: '',
              component: ExchangeRateManager,
            },
          ],
        },
      ],
    },
    // {
    //   meta: {
    //     label: i18n.t('common_615'),
    //   },
    //   submenus: [
    //     {
    //       path: '/cloud-bill-account',
    //       meta: {
    //         label: i18n.t('common_615'),
    //         hidden: () => store.getters.scope !== 'system',
    //       },
    //       component: Layout,
    //       children: [
    //         {
    //           name: 'CloudBillAccount',
    //           path: '',
    //           component: CloudBillAccount,
    //         },
    //       ],
    //     },
    //   ],
    // },
    // {
    //   meta: {
    //     label: i18n.t('op_9'),
    //   },
    //   submenus: [
    //     {
    //       path: '/sku-project-manager',
    //       meta: {
    //         label: i18n.t('op_10'),
    //         hidden: () => store.getters.scope !== 'system',
    //       },
    //       component: Layout,
    //       children: [
    //         {
    //           name: 'SKUProjectManager',
    //           path: '',
    //           component: SKUProjectManager,
    //         },
    //       ],
    //     },
    //     {
    //       path: '/sku-subcategory-manager',
    //       meta: {
    //         label: i18n.t('op_11'),
    //         hidden: () => store.getters.scope !== 'system',
    //       },
    //       component: Layout,
    //       children: [
    //         {
    //           name: 'SKUSubcategoryManager',
    //           path: '',
    //           component: SKUSubcategoryManager,
    //         },
    //       ],
    //     },
    //     {
    //       path: '/sku-original-manager',
    //       meta: {
    //         label: i18n.t('op_12'),
    //         hidden: () => store.getters.scope !== 'system',
    //       },
    //       component: Layout,
    //       children: [
    //         {
    //           name: 'SKUOriginalManager',
    //           path: '',
    //           component: SKUOriginalManager,
    //         },
    //       ],
    //     },
    //     {
    //       path: '/sku-rate-manager',
    //       meta: {
    //         label: i18n.t('op_44'),
    //         hidden: () => store.getters.scope !== 'system',
    //       },
    //       component: Layout,
    //       children: [
    //         {
    //           name: 'SKURateManager',
    //           path: '',
    //           component: SKURateManager,
    //         },
    //         {
    //           name: 'SKURateManagerCreate',
    //           path: 'create',
    //           component: SKURateManagerCreate,
    //         },
    //       ],
    //     },
    //   ],
    // },
  ],
}
